module.exports = __webpack_public_path__ + "img/TermsofUse_Collapsed_Small_Button-white.a46b5ac3.svg";